var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-setting",style:({
    background:_vm.data.backgroundColor,
    'margin-bottom': (_vm.data.marginBottom) / 16 + 'rem',
    'margin-left': (_vm.data.marginLeft) / 16 + 'rem',
    fontSize: (_vm.data.fontSize) / 16 + 'rem',
    fontWeight:_vm.data.fontWeight,
    color:_vm.data.titleColor,
    textAlign:_vm.data.textAlign,
    lineHeight: (_vm.data.lineHeight) / 16 + 'rem',
    fontFamily:_vm.data.family
  })},[_vm._v(_vm._s(_vm.data.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }